import get from 'lodash/get';

import { withData } from '@services/surveyDataProvider';

import PanelLegalNotice from './PanelLegalNotice';

export const mapSurveyDataToProps = (surveyData) => {
  const { cookieBanner } = surveyData;
  return {
    title: get(cookieBanner, 'legalInfo.title', ''),
    description: get(cookieBanner, 'legalInfo.message', '')
  };
};

export default withData(mapSurveyDataToProps)(PanelLegalNotice);
